import classNames from "classnames";
import React from "react";

import { useAppSelector } from "../../reducers";
import { defaults } from "../defaults";
import { IFilterOption } from "../models.interfaces";

import styles from "./GridFilter.module.scss";

interface IProps {
    filterID: string;
    option: IFilterOption;
    onChange: (
        optionNamespace: string,
        filterID: string,
        optionID: string,
        isSelected: boolean,
    ) => void;
}

export const GridFilterOption = React.memo((props: IProps): React.ReactNode => {
    const isSelected = useAppSelector((rootState) => {
        const state = rootState.productgrid2 || defaults;
        const filterState = state.filters[props.filterID];
        const selectedValues = filterState ? filterState.selectedValues : null;
        return selectedValues
            ? selectedValues.includes(props.option.id)
            : false;
    });

    const optionNamespace = useAppSelector((rootState) => {
        const state = rootState.productgrid2 || defaults;
        return state.products[0]?.product_class_slug || "";
    });

    const optionClasses = classNames({
        [styles.filterOption]: true,
        [`product-grid-filter__option--${props.option.id}`]: true,
    });
    const inputID = `check-box-${props.option.id}`;

    return (
        <div className={optionClasses}>
            <input
                id={inputID}
                type="checkbox"
                className="product-grid-filter__input al-product-grid__filter-input"
                value={props.option.id}
                checked={isSelected}
                onChange={(e) => {
                    props.onChange(
                        optionNamespace,
                        props.filterID,
                        props.option.id,
                        e.currentTarget.checked,
                    );
                }}
            />
            <label htmlFor={inputID}>
                <span className={styles.filterOptionLabel}>
                    {props.option.label}
                </span>
            </label>
        </div>
    );
});
